// extracted by mini-css-extract-plugin
module.exports = {"base":"NotificationIcon-module-base","countNumber":"NotificationIcon-module-count-number"};